import React from "react";
// import { SmallButton } from "../../UIkit";
import "../../../assets/css/boothInfo.css";

const BoothInfo = (props) => {
  // const rules = props.rules;
  return (
    <div className="booth-info--container">
      <div className="flex-column">
        <div className="flex-row">
          <div className="plofile-text__headline yu-gothic text-white">個展情報</div>
          {/* <div className="flex-row--justright">
            <SmallButton label="通知" />
          </div> */}
        </div>
        <div className="spacer-box--s" />
        <div className="booth-info__title yu-gothic text-white">{props.boothName}</div>
        <div className="spacer-box--s" />
        {/* <div className="plofile-text__basic yu-gothic text-white">ルール</div>
        <div className="spacer-box--sss" />
        {rules &&
          React.Children.toArray(
            rules.map((rule, index) => (
              <div className="plofile-text__basic yu-gothic text-white">
                {index + 1}:{rule}
              </div>
            ))
          )}
        <div className="spacer-box--s" /> */}
        <div className="plofile-text__basic yu-gothic text-white">{props.description}</div>
      </div>
    </div>
  );
};

export default BoothInfo;
